import React from 'react';
import { t } from '@citrite/translate';
import { AlertInfoIcon, Button, layout, typography } from '@citrite/web-ui-component';
import styled from '@emotion/styled';
import { useFormFactor } from 'App/Header/useFormFactor';
import { canShowFixIssueButton } from 'App/ProgressAlert/utils';
import { TroubleshootFixStatus } from 'Workspace/ResourceProvider/Context';

const StyledRecommendationContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: ${layout.space12};
`;

const StyledRecommendationText = styled.div`
	font-size: ${typography.sizes.xsml};
	font-weight: ${typography.weights.regular};
`;

const StyledRecommendationDescription = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${layout.space8};
`;

export const StyledButton = styled(Button.Primary)<{ isLargeFormFactor?: boolean }>`
	width: ${props => (props.isLargeFormFactor ? 'auto' : '100%')};
`;

interface RecommendationProps {
	remediationInfo: string;
	recommendationText: string;
	remediationAction?: () => void;
	fixStatus: TroubleshootFixStatus;
	shouldShowRemediation: boolean;
}
const StyledRecommendation = styled.div`
	font-size: ${typography.sizes.sml};
	font-weight: ${typography.weights.medium};
`;

const StyledRecommendationHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
`;

export const Recommendation: React.FC<RecommendationProps> = ({
	remediationInfo,
	recommendationText,
	remediationAction,
	fixStatus,
	shouldShowRemediation,
}: RecommendationProps) => {
	const { isLargeFormFactor } = useFormFactor();
	return (
		<StyledRecommendationContainer>
			<StyledRecommendationDescription>
				<StyledRecommendationHeader>
					<AlertInfoIcon size={16} />
					<StyledRecommendation>
						{t('Workspace:inspect_connection.recommendation')}
					</StyledRecommendation>
				</StyledRecommendationHeader>
				<StyledRecommendationText>
					{shouldShowRemediation ? remediationInfo : recommendationText}
				</StyledRecommendationText>
			</StyledRecommendationDescription>
			{remediationAction && isLargeFormFactor && canShowFixIssueButton(fixStatus) && (
				<StyledButton onClick={remediationAction} isLargeFormFactor={isLargeFormFactor}>
					{t('Workspace:inspect_connection.fix_issue')}
				</StyledButton>
			)}
		</StyledRecommendationContainer>
	);
};
